// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Vector3 } from './vector3';


export class Orientation {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):Orientation {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

origin(obj?:Vector3):Vector3|null {
  return (obj || new Vector3()).__init(this.bb_pos, this.bb!);
}

front(obj?:Vector3):Vector3|null {
  return (obj || new Vector3()).__init(this.bb_pos + 24, this.bb!);
}

top(obj?:Vector3):Vector3|null {
  return (obj || new Vector3()).__init(this.bb_pos + 48, this.bb!);
}

static sizeOf():number {
  return 72;
}

static createOrientation(builder:flatbuffers.Builder, origin_x: number, origin_y: number, origin_z: number, front_x: number, front_y: number, front_z: number, top_x: number, top_y: number, top_z: number):flatbuffers.Offset {
  builder.prep(8, 72);
  builder.prep(8, 24);
  builder.writeFloat64(top_z);
  builder.writeFloat64(top_y);
  builder.writeFloat64(top_x);
  builder.prep(8, 24);
  builder.writeFloat64(front_z);
  builder.writeFloat64(front_y);
  builder.writeFloat64(front_x);
  builder.prep(8, 24);
  builder.writeFloat64(origin_z);
  builder.writeFloat64(origin_y);
  builder.writeFloat64(origin_x);
  return builder.offset();
}

}
